import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Box } from 'reactjs-admin-lte'
import { Form, FormControl, FormGroup, ButtonToolbar, Button, InputGroup, Row, Col } from 'react-bootstrap'
import Select from 'react-select';
import Moment from 'moment';
import './Stock.css'
import CKAutocomplete from '../../component/element/CKAutocomplete';
import FontAwesome from 'react-fontawesome';
import DatePicker from '../../component/element/DatePicker'
import CkTimePicker from '../../component/element/CkTimePicker'
import WorkdocStore from '../../stores/WorkdocStore'
import StockStore from '../../stores/StockStore'
import AutopartStore from '../../stores/AutopartStore'
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');

const DEFAULT_ROW=  1
class StockToolBorrowingRecord extends Component {
  constructor(props) {
    super(props)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const curMonth = parseInt(Moment().format('MM'))
    const curDay = parseInt(Moment().format('DD'))
    const all_day = Moment().daysInMonth()
    let {messages} = this.props
    const optionsDay = []
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    for (var i=0;i<=all_day;i++) {
      if (i == 0) {
        var label = messages['All Month']
      } else {
        var label = i
      }
      optionsDay.push({
        value: i,
        label: label
      })
    }
    
    const optionsMonth = [
      { value: 0, label: messages['All Year'] },
      { value: 1, label: messages['January'] },
      { value: 2, label: messages['February'] },
      { value: 3, label: messages['March'] },
      { value: 4, label: messages['April'] },
      { value: 5, label: messages['May'] },
      { value: 6, label: messages['June'] },
      { value: 7, label: messages['July'] },
      { value: 8, label: messages['August'] },
      { value: 9, label: messages['September'] },
      { value: 10, label: messages['October'] },
      { value: 11, label: messages['November'] },
      { value: 12, label: messages['December'] }
    ];

    this.state = {
      loading:false,
      query:'',
      rowBeep:-1,
      is_search:false,
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth,
      optionsDay: optionsDay,
      defaultYear: yTh,
      defaultMonth: curMonth,
      defaultDay: curDay,
      customerList: [],
      stockApproverList: [],
      data: this.newEmptyRow(DEFAULT_ROW,curDay,curMonth,yTh),
      data: [],
    }

    this.pcInput = new Array(DEFAULT_ROW).fill('')
    this._approved_by = new Array(DEFAULT_ROW).fill('')
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    // if(this.props.open){
    //   let {defaultYear,defaultMonth,defaultDay} = this.state
    //   this.loadWorkdocAutocompleteOfficer()
    //   this.loadWorkdocAutocompleteStockApprover()
    //   this.loadStockBorrowingTool(defaultYear,defaultMonth,defaultDay)  
    // }
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show !== this.props.show){
      let {defaultYear,defaultMonth,defaultDay} = this.state
      this.loadWorkdocAutocompleteOfficer()
      this.loadWorkdocAutocompleteStockApprover()
      this.loadStockBorrowingTool(defaultYear,defaultMonth,defaultDay)  
    }
  }

  loadStockBorrowingTool(defaultYear,defaultMonth,defaultDay) {
    let that = this
    this.setState({loading:true})
    StockStore.loadStockBorrowingTool(defaultYear-543+'-'+defaultMonth+'-'+defaultDay,function(result) {
      let data = result.data.map((item,index)=>{
        item = Object.assign(that.newEmptyRow()[0],item)
        return item
      })
     
      let focusIndex = data.length
      if(data.length < DEFAULT_ROW){
        data = data.concat(that.newEmptyRow(DEFAULT_ROW-data.length));
        
      }else{
        data = data.concat(that.newEmptyRow(1))
      }
      
      that.pcInput = new Array(data.length).fill('')
      
      that.setState({ loading: false, data: data })     
      ReactDOM.findDOMNode(that.pcInput[focusIndex]).focus();
    },function(){
      that.setState({loading:false})
    })
  }


  getDefaultDate(dY,dM,dD){
    
    let defaultYear = (dY===undefined)?this.state.defaultYear:dY
    let defaultMonth = (dM===undefined)?this.state.defaultMonth:dM
    let defaultDay = (dD===undefined)?this.state.defaultDay:dD

    if(defaultDay*1<10){
      defaultDay  = '0'+defaultDay
    }
    if(defaultMonth*1<10){
      defaultMonth = '0'+defaultMonth
    }
    return ''+defaultDay+'/'+defaultMonth+'/'+defaultYear
  }

  newEmptyRow(number=1,defaultYear,defaultMonth,defaultDay) {
    
    return new Array(number).fill(null).map((item,index)=>{
      return {borrowing_item_id:'',productcode:'',description:'',
      borrowing_date:this.getDefaultDate(defaultYear,defaultMonth,defaultDay),
      return_date:'',borrower_name:'',approved_by:'',remark:'',is_submit:false,borrowing_time:'',return_time:''}
    })
  }

  loadWorkdocAutocompleteOfficer() {
    let that = this
    let officer = []
    WorkdocStore.loadWorkdocAutocompleteOfficer(function(result){
      result.data.forEach(element => {
        officer.push({
          id: element.nickname,
          label: element.nickname,
          emp_id: element.employee_id
          })
      });
      that.setState({customerList:officer})
    })  
  }

  loadWorkdocAutocompleteStockApprover() {
    let that = this
    let approver = []
    WorkdocStore.loadWorkdocAutocompleteStockApprover(function(result){
      result.data.forEach(element => {
        approver.push({
          id: element.nickname,
          label: element.nickname        })
      });
      that.setState({stockApproverList:approver})
    })  
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    const optionsDay = []
    let {messages} = this.props
    if (all_day) {
      for (var i=0;i<=all_day;i++) {
        if (i === 0) {
          var label = messages['Month']
        } else {
          var label = i
        }
        optionsDay.push({
          value: i,
          label: label
        })
      }
      if (all_day<this.state.defaultDay) {
        var defaultDay = 0
      } else {
        var defaultDay = this.state.defaultDay
      }
    } else {
      optionsDay.push({
        value: 0,
        label: messages['Month']
      })
      var defaultDay = 0
    }

    this.setState({ optionsDay: optionsDay, defaultDay:defaultDay })
    return defaultDay
  }

  onYearChange(e) {
    let {defaultYear,defaultMonth,defaultDay} = this.state
    var year = e.value - 543

    var date = year+"-"+this.state.defaultMonth
    defaultDay = this.getAllDayOfMonth(date)
    defaultYear = e.value
    this.setState({ defaultYear: defaultYear, activePage:1, defaultDay:defaultDay })

    this.loadStockBorrowingTool(defaultYear,defaultMonth,defaultDay)
  }

  onMonthChange(e) {
    let {defaultYear,defaultMonth,defaultDay} = this.state
    var date = this.state.defaultYear - 543+"-"+e.value
    defaultDay = this.getAllDayOfMonth(date)

    defaultMonth = e.value
    this.setState({ defaultMonth: defaultMonth, activePage:1, defaultDay:defaultDay })

    this.loadStockBorrowingTool(defaultYear,defaultMonth,defaultDay)
  }

  onDayChange(e) {
    let {defaultYear,defaultMonth,defaultDay} = this.state
    defaultDay = e.value
    this.setState({ defaultDay: defaultDay })

    this.loadStockBorrowingTool(defaultYear,defaultMonth,defaultDay)
  }

  convertDate(borrowing_date,return_date,index) {
    let {data} = this.state
    let {messages} = this.props
    let status = true
    let bD = borrowing_date.substring(0, 2)
    let bM = borrowing_date.substring(3, 5)
    let bY = borrowing_date.substring(6, 10)
    bY = (bY*1) - 543
    let rD = return_date.substring(0, 2)
    let rM = return_date.substring(3, 5)
    let rY = return_date.substring(6, 10)
    rY = (rY*1) - 543

    borrowing_date = bY+'-'+bM+'-'+bD
    return_date = rY+'-'+rM+'-'+rD

    let start = Date.parse(borrowing_date)
    let end = Date.parse(return_date)
    if (start>end) {
      status = false
      this._notificationSystem.addNotification({
        title: messages['Notice'],
        message: messages['Date Borrowing Date Return'],
        level: 'error',
        position: 'tc'
      })
    } else if (start===end) {
      let timefrom = new Date()
      let tempStart = data[index].borrowing_time.split(":")
      timefrom.setHours((parseInt(tempStart[0]) - 1 + 24) % 24)
      timefrom.setMinutes(parseInt(tempStart[1]))

      let timeto = new Date()
      let tempEnd = data[index].return_time.split(":")
      timeto.setHours((parseInt(tempEnd[0]) - 1 + 24) % 24)
      timeto.setMinutes(parseInt(tempEnd[1]))

      if (timefrom>timeto) {
        status = false
        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Time Borrowing Time Return'],
          level: 'error',
          position: 'tc'
        })
      }
    }
    return status
  }

  convertTime(borrowing_time,return_time,index) {
    let {data} = this.state
    let {messages} = this.props
    let borrowing_date = data[index].borrowing_date
    let return_date = data[index].return_date

    let status = true
    let timefrom = new Date()
    let tempStart = borrowing_time.split(":")
    timefrom.setHours((parseInt(tempStart[0]) - 1 + 24) % 24)
    timefrom.setMinutes(parseInt(tempStart[1]))

    let timeto = new Date()
    let tempEnd = return_time.split(":")
    timeto.setHours((parseInt(tempEnd[0]) - 1 + 24) % 24)
    timeto.setMinutes(parseInt(tempEnd[1]))
    if (return_date==='') {
      if (timefrom>timeto) {
        status = false
        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Time Borrowing Time Return'],
          level: 'error',
          position: 'tc'
        })
      }
    } else {
      if (borrowing_date===return_date) {
        if (timefrom>timeto) {
          status = false
          this._notificationSystem.addNotification({
            title: messages['Notice'],
            message: messages['Time Borrowing Time Return'],
            level: 'error',
            position: 'tc'
          })
        }
      }
    }
    return status
  }

  onDateChange(index,key,date) {
    let {data} = this.state
    let status = true
    status = this.convertDate(data[index].borrowing_date,date,index)
    if (!status) {
      data[index][key] = ''
      data[index]['borrowing_time'] = ''
      data[index]['return_time'] = ''
    } else {
      data[index][key] = date
    }
    if (date==='') {
      data[index]['borrowing_time'] = ''
      data[index]['return_time'] = ''
    }  

    this.setState({data:data})
  }

  onTimeSaved(index,key,time) {
    let {data} = this.state
    let status = true

    if (key==='borrowing_time'&&data[index].return_time!=='') {
      status = this.convertTime(time,data[index].return_time,index)
    } else if (key==='return_time'&&data[index].borrowing_time!=='') {
      status = this.convertTime(data[index].borrowing_time,time,index)
    }
    
    if (!status) {
      data[index][key] = ''
    } else {
      data[index][key] = time
    }
    this.setState({data:data})
  }

  onTextChange(index,key,e) {
    let {data} = this.state
    data[index][key] = e.target.value
    this.setState({data:data})
  }

  onTextSelect(index,key,e) {
    let {data} = this.state
    data[index][key] = e
    this.setState({data:data})
    if (key=='borrower_name')
      this._approved_by[index].onFocus()
  }

  onSearchKeyPress(index, key, target) {
    if (target.charCode == 13) {
      let { data } = this.state
    
      let that = this, foundIndex = -1
      this.setState({ loading: false,rowBeep:index })
      let productCode = data[index][key];
      data.map((item, iindex) => {
        if (item.productcode === productCode && iindex !== index) {
          foundIndex = iindex
        }
        return item
      })
      if (foundIndex >= 0) {
        let item = data[foundIndex]
        data[index].description = item.description
        data[index].productcode = item.productcode

        that.setState({ loading: false, data: data })
        
      } else {
        AutopartStore.loadStockProductCode('tool',productCode,function(result){
          if (result.data.length > 0) {
            let item = result.data[0]
            data[index].description = item.description
            data[index].productcode = item.productcode

            if (index == data.length - 1) {
              //End index
              data = data.concat(that.newEmptyRow(1))
              that.pcInput[index + 1] = ''
            }       
            that.setState({ loading: false, data: data })     
            ReactDOM.findDOMNode(that.pcInput[index + 1]).focus();
          } else {
            data[index].productcode = ''            
            that.setState({ loading: false, data: data })
          }          
        })
      }

      setTimeout(function () {
        that.setState({ rowBeep: -1 })
      }, 1500);
    }
  }

  onTextKeyPress(index,key,e) {
    if (e.charCode === 13) {
      e.preventDefault()

      let {customerList,data} = this.state
      let {messages} = this.props
      let checkSearch = false
      let value = ''

      customerList.forEach(function(item,index) {
        if (item.emp_id===e.target.value) {
          checkSearch = true
          value = item.label
        }
      })

      if (checkSearch) {
        data[index][key] = value
        this._approved_by[index].onFocus()
      } else {
        data[index][key] = ''
        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Code Not Found']+' ' + e.target.value + ' '+messages['Please Try Again'],
          level: 'error',
          position: 'tc'
        });
      }

      this.setState({data:data})  
    }  
  }

  getRowClassName(item, index) {
    let { rowBeep } = this.state    
    let className = item.is_submit?'bg-gray-light':''
    if (rowBeep === index) {
      className = ' bg-yellow'
    }
    
    return className
  }

  renderRowData() {
    let {data,defaultDay,defaultMonth} = this.state
    let {messages} = this.props
    if(defaultDay<10)
      defaultDay = '0'+defaultDay

    if(defaultMonth<10)
      defaultMonth = '0'+defaultMonth

    if (data===undefined||data.length===0) {
      return(<tr><td colSpan={10}>{messages['No Data']}</td></tr>)
    } else { 
      return(
        data.map((item,index) => {
          return (
            <tr key={index} className={this.getRowClassName(item,index)}>
              <td className='text-center'>{index+1}</td>
              <td className='text-center'>
                <FormControl value={item.productcode} 
                ref={(input) => { this.pcInput[index] = input; }}
                disabled={item.is_submit}
                onChange={this.onTextChange.bind(this,index,'productcode')}
                onKeyPress={this.onSearchKeyPress.bind(this, index, 'productcode')} 
                />
              </td>
              <td className='text-center'>
                <FormControl value={item.description} 
                disabled={item.is_submit}
                onChange={this.onTextChange.bind(this,index,'description')}></FormControl>
              </td>
              <td className='text-center'>
                <FormControl style={{textAlign:'center'}}                 
                value={item.borrowing_date} 
                disabled={true}></FormControl>
              </td>
              <td className='text-center'>
                <DatePicker
                  disabled={item.is_submit}
                  value={item.return_date}
                  onChange={this.onDateChange.bind(this,index,'return_date')}
                  showIcon={false}
                  showFooter={true}
                  buddhistEra={true}
                  style={{ display: 'inline-block' }}
                />
              </td>
              <td className='text-center'>
                <CkTimePicker
                  disabled={item.is_submit}
                  value={item.borrowing_time}
                  onTimeSaved={this.onTimeSaved.bind(this,index,'borrowing_time')}
                  showIcon={false}
                  minuteStep={5}
                />
              </td>
              <td className='text-center'>
                <CkTimePicker
                  disabled={item.is_submit}
                  value={item.return_time}
                  onTimeSaved={this.onTimeSaved.bind(this,index,'return_time')}
                  showIcon={false}
                  minuteStep={5}
                />
              </td>
              <td className='text-center'>
                <CKAutocomplete
                  disabled={item.is_submit}
                  top={'-34px'}
                  choiceStyle={{width:'200px'}}
                  items={this.state.customerList}
                  value={item.borrower_name}
                  onChange={this.onTextChange.bind(this,index,'borrower_name')}
                  onSelect={this.onTextSelect.bind(this,index,'borrower_name')}
                  onKeyPress={this.onTextKeyPress.bind(this,index,'borrower_name')}
                />
              </td>
              <td className='text-center'>
                <CKAutocomplete
                  disabled={item.is_submit}
                  top={'-34px'}
                  choiceStyle={{width:'200px'}}
                  items={this.state.stockApproverList}
                  value={item.approved_by}
                  onChange={this.onTextChange.bind(this,index,'approved_by')}
                  onSelect={this.onTextSelect.bind(this,index,'approved_by')}
                  onKeyPress={this.onTextKeyPress.bind(this,index,'approved_by')}
                  ref={(input) => { this._approved_by[index] = input; }}
                />
              </td>
              <td className='text-center'><FormControl value={item.remark} 
              disabled={item.is_submit}
              onChange={this.onTextChange.bind(this,index,'remark')}></FormControl></td>
            </tr>
          )
        })  
      )    
    }      
  }

  onRowAdd(number){
    let {data} = this.state
    data = data.concat(this.newEmptyRow(number))
    
    this.pcInput = new Array(data.length).fill('')
    this.setState({data:data})
  }

  renderNewItemButton(){
    let {is_search} = this.state
    let {messages} = this.props
    if(is_search){
      return (<div/>)
    }else
    return (
      <Row style={{marginTop:'10px'}}>
        <Col md={12}>
          <ButtonToolbar>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;{messages['Add Item']}</Button>
            <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;{messages['Add 10 Item']}</Button>
          </ButtonToolbar>       
        </Col>    
      </Row>
    )
  }

  onSaveClick(e){
    let {data,defaultYear,defaultMonth,defaultDay} = this.state
    let {messages} = this.props
    let postDate = {itemlist:data}
    this.setState({loading:true,is_submit:false})
    let that = this
    StockStore.saveStockBorrowing('tool',postDate,function(result) {
      if(result.status === 'OK') {
        that.loadStockBorrowingTool(defaultYear,defaultMonth,defaultDay)
        that._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Save Successfully'],
          level: 'info',
          position: 'tc',        
        });
      }else{  
        that.setState({loading:false})
      }
    },function(){
      that.setState({loading:false})
    })
  }

  onSubmitClick(e){
    let {data,defaultYear,defaultMonth,defaultDay} = this.state
    let {messages} = this.props
    let postDate = {itemlist:data,is_submit:true}
    this.setState({loading:true})
    let that = this
    StockStore.saveStockBorrowing('tool',postDate,function(result) {
      if(result.status ==='OK') {
        that.loadStockBorrowingTool(defaultYear,defaultMonth,defaultDay)
        that._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Save Permanently Successfully'],
          level: 'info',
          position: 'tc',        
        });
      }else{  
        that.setState({loading:false})
      }
    },function(){
      that.setState({loading:false})
    })
  }

  onClearClick(){
    this.setState({query:'',is_search:false})
  }

  onQueryChange(e){
    this.setState({query:e.target.value})
  }

  onSearchClick(){
    let {query} = this.state
    if(query!=='')
      this.setState({is_search:true})
  }

  onCloseClick(e){
    
  }

  renderTable() {
    let {messages} = this.props
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid table-tool' style={{minWidth:'1280px',marginBottom:'0'}}>
          <thead>
            <tr>
              <th rowSpan={2} className='text-center' style={{ width: '50px' }}>{messages['Number']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '150px' }}>{messages['Barcode']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '300px' }}>{messages['Item']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '150px' }}>{messages['Date']}<br />{messages['Borrow']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '150px' }}>{messages['Date']}<br />{messages['Back']}</th>
              <th colSpan={2} className='text-center'>
                {messages['Time']}
              </th>
              <th rowSpan={2} className='text-center' style={{ width: '100px' }}>{messages['Technician/Department']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '100px' }}>{messages['Approvers']}</th>
              <th rowSpan={2} className='text-center' style={{ width: '150px' }}>{messages['Remark']}</th>
            </tr>
            <tr>
              <th className='text-center' style={{ width: '90px' }}>{messages['Borrow']}</th>
              <th className='text-center' style={{ width: '90px' }}>{messages['Back']}</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>  
    )
  }

  render() {
    let {loading,query} = this.state
    let {messages} = this.props
    var style = {
      NotificationItem: { // Override the notification item
        DefaultStyle: { // Applied to every notification, regardless of the notification level
          margin: '10px 5px 2px 1px',
          fontSize:'30px',
          width:'400px',
          textAlign:'center'
        },
      }
    }
    return (
      <Box loading={loading}>
        <Box.Header border={true}>
          {messages['List Tools Borrowing']}
	      </Box.Header>
        <Box.Body>
          <Form inline style={{marginBottom:'5px'}}>
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultYear }
                options={this.state.optionsYear}
                style={{ width: "150px" }}
                onChange={ this.onYearChange.bind(this) }
              />
            </FormGroup>  
            {' '}
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultMonth }
                options={this.state.optionsMonth}
                style={{ width: "180px" }}
                onChange={ this.onMonthChange.bind(this) }
              />
            </FormGroup>  
            {' '}
            <FormGroup>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultDay }
                style={{ width: "100px" }}
                options={this.state.optionsDay}
                onChange={this.onDayChange.bind(this)}
              />
            </FormGroup>
            {' '}
            <FormGroup>
              <InputGroup>
                <FormControl placeholder={messages['Searching Technician']+'...'} value={query} onChange={this.onQueryChange.bind(this)}></FormControl>
                <InputGroup.Addon
                  className=''
                  onClick={this.onSearchClick.bind(this)}
                >
                  <FontAwesome name='search' />
                </InputGroup.Addon>
              </InputGroup>
            </FormGroup>
            {' '}
            <Button bsStyle='default' 
            onClick={this.onClearClick.bind(this)}>
            <FontAwesome name='eraser' />&nbsp;{messages['Delete Search']}</Button>
          </Form>
          {this.renderTable()}
          {this.renderNewItemButton()}
        </Box.Body>
        <Box.Footer>
          <ButtonToolbar className='pull-right'>
            <Button bsStyle='warning' onClick={this.onSubmitClick.bind(this)}><FontAwesome name='save' />&nbsp;{messages['Save Permanently']}</Button>
            <Button bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;{messages['Save']}</Button>
            <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;{messages['Close']}</Button>
          </ButtonToolbar>
        </Box.Footer>
        <NotificationSystem ref="notificationSystem" style={style} />                     
      </Box>
    )
  }

}

StockToolBorrowingRecord.defaultProps = {
  show:false
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockToolBorrowingRecord}),null,null,{withRef:true},
)(StockToolBorrowingRecord);


// WEBPACK FOOTER //
// ./src/view/stock/StockToolBorrowingRecord.js